import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/Button';
import { Card, CardBody } from '../../components/ui/Card';
import { EmptyState } from '../../components/ui/States';
import { MEMBERS_WIZARD_REFUSAL } from '../brand/brandCopy';
import { editPagePath } from '../brand/paths';
import { WizardFrame } from './WizardFrame';

/**
 * What a member who cannot change the brand sees instead of Brand Setup (E30; web.md §4.1): who can, and
 * the way back to Edit Brand Workspace. Nothing is read or written for them here.
 */
export function MembersRefusal({ slug }: { slug: string }) {
  const navigate = useNavigate();
  return (
    <WizardFrame>
      <Card>
        <CardBody>
          <EmptyState
            title={MEMBERS_WIZARD_REFUSAL.title}
            description={MEMBERS_WIZARD_REFUSAL.message}
            action={
              <Button type="button" variant="secondary" onClick={() => navigate(editPagePath('brand', slug))}>
                {MEMBERS_WIZARD_REFUSAL.action}
              </Button>
            }
          />
        </CardBody>
      </Card>
    </WizardFrame>
  );
}
